import React, { useReducer } from "react";
import AuthContext from "./AuthContext";
import Login from "./Login";

const defaultState = {//login token
  access_token: null,//localStorage.getItem("app_token"),
  pupil: null
};

//put here the drip thing that checks if the server exists

const authReducer = (state, action) => {
  switch (action.type) {
    case "update_token":
      const { access_token } = action.payload;
      localStorage.setItem("app_token", access_token);
      return {
        ...state,
        access_token
      };
    case "update_pupil":
      const pupil = action.payload;
      return {
        ...state,
        pupil
      };
    case "remove_token":
      return {
        access_token: null,
        pupil: null
      };
    default:
      return state;
  }
};

const AppWrapper = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, defaultState);
  
  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {state.access_token !== null ? children : <Login />}
    </AuthContext.Provider>
  );
};

export default AppWrapper;